import React from 'react';
import {steps, stepsIATU} from "./MenuSteps";
import {DefaultButton, PrimaryButton} from '@fluentui/react';
import {nextStep} from "../../actions/WizardActions/WizardAction.js"
import connect from "react-redux/es/connect/connect";
import {addElement} from "../../actions/CreateSiteActions/createSiteActions";
import {clearCache} from  "../../actions/WizardActions/ClearChache.js"
import {
    SET_CURRENT_STEP
} from "../../actions/types";
import Stepper from "../CreateSite/CommonComponents/Stepper";
import {updateValidationStatus} from "../../actions/ValidationActions/validateStep2Acitons";

class CreateGuide extends React.Component {
    constructor(props)
    {
        super(props)
        this.state = {
            index : 0,
            currentStep: steps[0].rightPane,
            currentLeft: steps[0].leftPane,
            validator: steps[0].validator,
            showDisplayMessage : false,
            nextPossible : true,
            backwardPossible: false,
            reuse : props.Created === false,
            isCustomTemplate : false,
            stepsTest : props.isIATU || props.isIAPCP ? stepsIATU : steps
        }
    }

    componentDidMount(): void {
        if (this.props.Created === true) {
            this.props.clearCache();
        }
    }

    componentDidUpdate(prevProps, prevState): void {
        
        if (!(prevProps.isIATU || prevProps.isIAPCP) && (this.props.isIATU || this.props.isIAPCP)) {
            this.setState({stepsTest: stepsIATU});
        }
        else if ((prevProps.isIATU || prevProps.isIAPCP) && !(this.props.isIATU || this.props.isIAPCP)) {
            this.setState({stepsTest: steps });
        }

        // if(!(this.props.Template === null) && this.props.Template.isCustom === true && !(prevProps.Template === null) && prevProps.Template.isCustom !== this.props.Template.isCustom)
        // {
        //     this.setState({stepsTest : stepsIATU});
        // }
        // if(!(this.props.Template === null) && this.props.Template.isCustom === false && !(prevProps.Template === null) && prevProps.Template.isCustom !== this.props.Template.isCustom)
        // {
        //     this.setState({stepsTest : steps });
        // }
    }
    
    continueOrder()
    {
        const current  = this.props.CurrentStep;
        this.setState({reuse:false, index: current, currentStep: this.state.stepsTest[current].rightPane, validator: this.state.stepsTest[current].validator,
            currentLeft: this.state.stepsTest[current].leftPane},()=> this.setNavigateButtons());
    }

    newOrder()
    {
        this.props.setCurrentStep(SET_CURRENT_STEP, 0);
        this.props.clearCache();
        this.setState({reuse:false});
    }

    canGoNext ()
    {
        const current = this.state.index;
        if(current + 2 > this.state.stepsTest.length)
        {
            this.setState({nextPossible: false})
        }
        else
        {
            this.setState({nextPossible: true})
        }
    }
    canGoBackward ()
    {
        const current = this.state.index;
        if(current  < 1)
        {
            this.setState({backwardPossible: false})
        }
        else
        {
            this.setState({backwardPossible: true})
        }
    }
    setNavigateButtons()
    {
        //console.log(this.state.index);
        this.canGoNext();
        this.canGoBackward();
    }
    setNextStep()
    {
        if(this.props.IsFrozen) return;
        let current = this.props.CurrentStep;
        this.props.setCurrentStep(SET_CURRENT_STEP, this.props.CurrentStep + 1);
        this.setState({
                index : current+1,
                currentStep : this.state.stepsTest[current+1].rightPane,
                currentLeft : this.state.stepsTest[current+1].leftPane,
                validator: this.state.stepsTest[current+1].validator },
            () => this.setNavigateButtons())
        window.scrollTo(0, 0);

    }
    setPreviousStep()
    {
        if(this.props.IsFrozen) return;
        let current = this.props.CurrentStep;
        this.props.setCurrentStep(SET_CURRENT_STEP, this.state.index - 1);
        this.setState({
                index : current-1,
                currentStep : this.state.stepsTest[current-1].rightPane,
                currentLeft : this.state.stepsTest[current-1].leftPane,
                validator: this.state.stepsTest[current-1].validator },
            () => this.setNavigateButtons())
        window.scrollTo(0, 0);
    }
    nextStepRequested()
    {
        this.props.nextStep(true);
        if(this.state.validator())
        {
            this.props.nextStep(false);
            this.setNextStep();
        }
    }

    render() {
        if (this.props.Created && this.state.index === 0)
            return null;

        const nextVisible = this.state.nextPossible;
        const backVisible = this.state.backwardPossible && !this.props.Created && !this.props.IsFrozen;
        const display = this.state.reuse === false
        ?  <div>
            <div className="create-guide fadeIn">
                <div className='left-pane'>
                    <div className=''>
                        {this.state.currentLeft}
                    </div>
                    <div className='progress-bar'><Stepper stepsA={this.state.stepsTest} /></div>
                </div>
                <div className='right-pane'>
                    <div className='inside-pane'>
                        {this.state.currentStep}
                    </div>
                </div>
                {backVisible ? <div className='nav-button-left'> <DefaultButton onClick={this.setPreviousStep.bind(this)}>Back</DefaultButton> </div> : null}
                {nextVisible? <div className='nav-button-right'> <DefaultButton onClick={this.nextStepRequested.bind(this)}>Next</DefaultButton></div> : null}
            </div>
        </div>
        :
            <div className="create-guide fadeIn">
                <div style={{padding:'100px 100px 100px 100px'}}>
                    <h3> It seems that you have unfinished order.</h3>
                      <h3> Would you like to continue previous order or create new one?</h3>
                    <PrimaryButton style={{position:'absolute',top:'30%',left:'20%', width: '200px'}} onClick={this.continueOrder.bind(this)}> Continue</PrimaryButton>
                    <PrimaryButton style={{position:'absolute',top:'30%',left:'60%', width: '200px'}} onClick={this.newOrder.bind(this)}> New Order</PrimaryButton>
                </div>

            </div>

        return (
            <div>
              {display}
            </div>
        );
    }
}

const mapStateToProps  = state => ({
    CurrentStep: state.wizard.currentStep,
    Created: state.newSite.OrderCreated,
    IsFrozen: state.wizard.freezeWizard,
    isIATU: state.newSite.isIATU,
    isIAPCP: state.newSite.isIAPCP,
    Template: state.newSite.Template
})


const mapActionToProp =
    {
        clearCache: clearCache,
        updateValidationStatus: updateValidationStatus,
        setCurrentStep: addElement,
        setCreated : addElement,
        nextStep : nextStep
    }

export default connect(mapStateToProps,mapActionToProp)(CreateGuide)




// WEBPACK FOOTER //
// ./src/components/CreateSiteGuide/CreateGuide.js